import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createQueryHook from '@segment/utils/createQueryHook';
import deterministicShuffle from '@segment/utils/deterministicShuffle';
import { useCatalogIndex } from '@segment/contexts/catalogIndex';
import { fetchIntegrations } from './common';
export var similarIntegrationsAttributesToFetch = ["contentType", "slug", "name", "logo", "categories", "type", "beta"];
export var fetchRandomSimilarIntegrations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var catalogIndex, random, category, slug, data, similarIntegrations;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            catalogIndex = _ref.catalogIndex, random = _ref.random, category = _ref.category, slug = _ref.slug;
            _context.next = 3;
            return fetchIntegrations({
              catalogIndex: catalogIndex,
              query: "",
              distinct: 1,
              category: category,
              hitsPerPage: 20,
              destination: true,
              source: true
            });

          case 3:
            data = _context.sent;
            similarIntegrations = random ? deterministicShuffle(data.hits) : data.hits;
            return _context.abrupt("return", similarIntegrations.filter(function (h) {
              return h.slug && normalizeSlug(h.slug) !== slug;
            }).slice(0, 4));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRandomSimilarIntegrations(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var normalizeSlug = function normalizeSlug(slug) {
  var startOffset = slug.startsWith("/") ? 1 : 0;
  var endOffset = slug.endsWith("/") ? -1 : 0;
  return slug.substring(startOffset, slug.length + endOffset);
};

export var createSimilarIntegrationsQuery = function createSimilarIntegrationsQuery(catalogIndex, _ref3) {
  var slug = _ref3.slug,
      category = _ref3.category,
      random = _ref3.random,
      amount = _ref3.amount;
  return [["catalog/SimilarIntegrationsQuery", slug !== null && slug !== void 0 ? slug : null, category !== null && category !== void 0 ? category : null, random !== null && random !== void 0 ? random : null, amount !== null && amount !== void 0 ? amount : null], function () {
    return fetchRandomSimilarIntegrations({
      catalogIndex: catalogIndex,
      random: random,
      slug: slug,
      amount: amount,
      category: category
    });
  }];
};
export var useSimilarIntegrationsQuery = createQueryHook(createSimilarIntegrationsQuery, useCatalogIndex, {
  staleTime: Infinity
});